
import Opportunity from '@/models/Opportunity'
import ViewModel from '@/models/ViewModel'
import { Component, Prop, Ref } from 'vue-property-decorator'
import DatePicker from '@/components/DatePicker/DatePicker.vue'
import FormInput from '@/components/FormInput/FormInput.vue'
import { currencyMask } from '@/models/interface/Masks'
import WebMessage from '@/models/WebMessage'
import MediaPlan from '@/models/MediaPlan'
import SelectPicker from '@/components/SelectPicker/SelectPicker.vue'
import CheckboxInput from '@/components/CheckboxInput/index.vue'

@Component({
  components: {
    DatePicker,
    FormInput,
    SelectPicker,
    CheckboxInput,
  },
})
export default class IsForecast extends ViewModel {
  @Ref()
  public lost_validator!: any

  @Ref()
  public readonly stageChanger!: any

  @Prop({ required: true })
  public value!: boolean

  @Prop({ required: false })
  public disabled!: boolean

  @Prop({ required: false, default: undefined })
  public closed!: boolean

  @Prop({ required: true })
  public onlyEdit!: Array<any>

  @Prop({ required: false, default: 'switch' })
  public type!: string

  @Prop({ required: false })
  public hideSave!: boolean

  public lost_categories: any = Opportunity.option_list.lost_categories

  public openPopOver: boolean = false

  public loading: boolean = false

  public id: any = this.randomUUID()

  public get local_opportunity() {
    return this.value
  }

  public set local_opportunity(val: any) {
    this.$emit('update:value', val)
  }

  public onIsForecastChange(val: boolean) {
    if (!this.loading) {
      this.$emit('updated', val)
      this.local_opportunity.save()
      this.openPopOver = false
    }
  }

  public selected_targeting: boolean = false

  public check_media_plan: boolean = false

  public checking_media_plan: boolean = false

  public cant_be_saved: boolean = false

  public media_plan!: MediaPlan

  public get masks() {
    return {
      currency: currencyMask,
    }
  }

  public mounted() {
    this.$root.$on('bv::popover::show', (bvEventObj: any) => {
      if (
        bvEventObj.componentId !== `is-forecast-popover-${this.local_opportunity.id}-${this.id}`
      ) {
        this.openPopOver = false
      }
    })
  }

  public showWarning() {
    if (!['won', 'lost'].includes(this.local_opportunity.status)) {
      this.openPopOver = true
      return
    }
    if (this.closed) {
      WebMessage.warning('Closed opportunities cannot be updated.')
      return
    }
    WebMessage.warning("This opportunity forecast can't be updated right now.")
  }

  public resetOppMPSearch() {
    this.check_media_plan = false
    this.loading = false
    this.cant_be_saved = false
    this.selected_targeting = false
  }
}
